module.exports = __webpack_public_path__ + "eff531e26c97d2363c35d800899d8c8f.png";